/* eslint-disable no-var */
import { stylesheet } from '@stylable/runtime/esm/runtime';
var host = /* @__PURE__ */ stylesheet();
export var sts = /* #__PURE__ */ host.sts;
export var stc = /* #__PURE__ */ host.stc;